import {
  setAuthUser,
  setLoading,
  setConfirmation,
  setOfferData,
  setCountryCode,
} from "./../slices/authSlice";

import { setUser } from "../slices/userSlice";

import { AuthService, CommonService, UserService } from "td_server/services";
import { setGlobalLoader } from "./loaderAction";
import { env } from "../../env";
import { getDeviceInfo, removeCountryCode } from "../../utils/HelperFunctions";
import { resetUserAction } from "./userAction";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
import CleverTapService from "../../utils/analyics/CleverTapService";
import {
  calculateLoginGapInDays,
  clearOtpSentTime,
  formatPhoneNumber,
  getDeviceTypeFromUserAgent,
  getIsoTimestamp,
  getOtpVerificationTimeSeconds,
  incrementOtpAttempt,
  incrementVerifyOtpAttempt,
  storeOtpSentTime,
  trackCleavertapEvent,
} from "../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../utils/analyics/analyticsEvents";
import { trackedAsync } from "../../utils/analyics/trackedAsync";

export const loginWithPhoneNumber =
  (phoneNumber: any, selectedCountryCode = "91") =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      if (!phoneNumber || phoneNumber?.length === 0) {
        dispatch(setLoading(false));
        return;
      }

      const attemptNumber = incrementOtpAttempt(
        formatPhoneNumber(phoneNumber, selectedCountryCode),
      );
      storeOtpSentTime(formatPhoneNumber(phoneNumber, selectedCountryCode));
      trackCleavertapEvent(ANALYTICS_EVENTS.OTP_Sent, {
        Phone_Number: formatPhoneNumber(phoneNumber, selectedCountryCode),
        Attempt_Number: attemptNumber ?? 1,
      });

      const otpResponse = await trackedAsync(()=> AuthService.sendOtpLessOtp(
        `${phoneNumber}`,
        selectedCountryCode,
      ));

      const confirmation = otpResponse;

      if (confirmation.orderId && confirmation.orderId.length > 0) {
        dispatch(setAuthUser(phoneNumber));
        dispatch(setConfirmation(confirmation));
      } else {
        dispatch(setLoading(false));
        return Promise.reject(confirmation);
      }

      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (error: any) {
      console.log("ERROR : ", error);
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const resendOtpAction =
  (_confirmation: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      let authUser = getState().auth.user;
      const resendResult: any = await trackedAsync(()=> AuthService.reSendOtpLessOtp(
        _confirmation.orderId,
      ));
      const confirmation = resendResult;
      // dispatch(setAuthUser(authUser));
      if (confirmation.orderId && confirmation.orderId.length > 0) {
        dispatch(setConfirmation(confirmation));
      } else {
        dispatch(setLoading(false));
        return Promise.reject("");
      }

      dispatch(setLoading(false));
      return Promise.resolve(true);
    } catch (error: any) {
      console.log("Error: ", error);
      dispatch(setLoading(false));
      return Promise.reject(error);
    }
  };

export const resendOtpActionRegister =
  (phoneNumber: any, _confirmation: any) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      let authUser = getState().auth.user;

      const confirmation: any = await trackedAsync(()=> AuthService.reSendOtpLessOtp(
        _confirmation.orderId,
      ));
      // dispatch(setAuthUser(authUser));
      if (confirmation.orderId && confirmation.orderId.length > 0) {
        dispatch(setConfirmation(confirmation));
      } else {
        dispatch(setLoading(false));
        return Promise.reject("");
      }
      dispatch(setLoading(false));
      return Promise.resolve(true);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject(error);
    }
  };

export const checkUserDetails = (phoneNumber: any) => async (dispatch: any) => {
  try {
    dispatch(setGlobalLoader(true));
    const checkUser = await trackedAsync(()=> AuthService.handleUserLogin(phoneNumber));
    let userDetails: any = null;
    if (checkUser?.newUser) {
      dispatch(setLoading(false));
      userDetails = {
        newUser: checkUser.newUser,
        phoneNumber: removeCountryCode(checkUser?.phoneNumber),
      };
    } else {
      userDetails = checkUser.user;
    }
    localStorage.setItem(LOCALSTORAGE_KEY.USERINFO, JSON.stringify(userDetails));
    if (userDetails?.id) {
      CleverTapService.onUserLogin({
        Identity: String(userDetails?.id ?? userDetails?.phoneNumber),
        Phone: String(userDetails?.phoneNumber ?? ""),
        Name: `${userDetails?.personalInfo?.firstName ?? ""} ${userDetails?.personalInfo?.lastName ?? ""}`,
        Email: userDetails?.personalInfo?.email || "",
        DOB: userDetails?.personalInfo?.dateOfBirth ?? "",
        Photo: userDetails?.personalInfo?.profilePictureUrl ?? "",
        Created_Date: getIsoTimestamp(),
        Last_Login_Date: getIsoTimestamp(),
      });
      await dispatch(
        updateLastLogin(String(userDetails?.id), true, {
          userName: `${userDetails?.personalInfo?.firstName ?? ""} ${userDetails?.personalInfo?.lastName ?? ""}`,
          phoneNumber: String(userDetails?.phoneNumber ?? ""),
          device: navigator.userAgent,
        }),
      );
    } else {
      CleverTapService.logout();
    }
    dispatch(setUser(userDetails));
    dispatch(setLoading(false));
    dispatch(setGlobalLoader(false));
    return Promise.resolve("");
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("InvalidOtp");
  }
};
export const verifyOtp =
  (
    otp: any,
    _confirmation: any,
    phoneNumber: any,
    selectedCountryCode: any = "91",
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      let response: any = {};
      //Logic for hardcoded OTP for test ENV
      if (otp === "121212" && (env === "dev" || env === "test")) {
        response.isOTPVerified = true;
      } else {
        const responseVerifyOtp: any = await trackedAsync(()=> AuthService.verifyOtpLessOtp(
          phoneNumber,
          _confirmation.orderId,
          otp,
          selectedCountryCode,
        ));
        response = responseVerifyOtp;
      }

      dispatch(setLoading(false));

      var userDetails = null;
      if (response.isOTPVerified) {
        const verificationTimeSeconds = getOtpVerificationTimeSeconds(
          formatPhoneNumber(phoneNumber, selectedCountryCode),
        );
        trackCleavertapEvent(ANALYTICS_EVENTS.OTP_Verified_Success, {
          Phone_Number: formatPhoneNumber(phoneNumber, selectedCountryCode),
          Verification_Time_Seconds: verificationTimeSeconds,
        });
        clearOtpSentTime(formatPhoneNumber(phoneNumber, selectedCountryCode));
        dispatch(setConfirmation(response));
        const checkUser = await trackedAsync(()=>AuthService.handleUserLogin(
          `+${selectedCountryCode}${phoneNumber}`,
        ));
        //Added for new user test
        // checkUser.newUser = true;
        // checkUser.phoneNumber = phoneNumber
        if (checkUser?.newUser) {
          dispatch(setLoading(false));
          let newUserDetails = {
            newUser: checkUser.newUser,
            phoneNumber: removeCountryCode(checkUser?.phoneNumber),
            dialCode: selectedCountryCode,
          };
          userDetails = newUserDetails;
          localStorage.setItem(
            LOCALSTORAGE_KEY.SIGNUPUSER,
            JSON.stringify(userDetails),
          );
        } else {
          userDetails = checkUser.user;
          dispatch(setUser(userDetails));
          localStorage.setItem(LOCALSTORAGE_KEY.USERINFO, JSON.stringify(userDetails));
          // dispatch(setUser(userDetails));
          await dispatch(
            updateLastLogin(String(userDetails?.id), true, {
              userName: `${userDetails?.personalInfo?.firstName ?? ""} ${userDetails?.personalInfo?.lastName ?? ""}`,
              phoneNumber: String(userDetails?.phoneNumber ?? ""),
              device: navigator.userAgent,
            }),
          );
          
          dispatch(setLoading(false));
          dispatch(setGlobalLoader(false));
        }
        if (userDetails?.id) {
          // Setup clearTap profile
          CleverTapService.onUserLogin({
            Identity: String(userDetails?.id || userDetails?.phoneNumber),
            Phone: userDetails?.phoneNumber,
            Name: `${userDetails?.personalInfo?.firstName} ${userDetails?.personalInfo?.lastName}`,
            Email: userDetails?.personalInfo?.email || "",
            DOB: userDetails?.personalInfo?.dateOfBirth ?? "",
            Photo: userDetails?.personalInfo?.profilePictureUrl ?? "",
            Created_Date: getIsoTimestamp(),
            Last_Login_Date: getIsoTimestamp(),
          });
          // track login and signup events
          if (!checkUser?.newUser) {
            trackCleavertapEvent(ANALYTICS_EVENTS.Login_Success,{
              Phone_Number: userDetails?.phoneNumber,
              Login_Type: "OTP",
              Is_New_User: checkUser?.newUser ? true : false,
              User_ID: String(userDetails?.id || userDetails?.phoneNumber),
              Previous_Login_Gap_Days: calculateLoginGapInDays(userDetails?.userUpdatedAt || getIsoTimestamp()),
              Name: `${userDetails?.personalInfo?.firstName} ${userDetails?.personalInfo?.lastName}`,
              Language_Preference: localStorage?.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en",
              Device_Type: getDeviceTypeFromUserAgent(),
            })
          }
        } else {
          CleverTapService.logout();
        }
        return Promise.resolve(userDetails);
      } else {
        dispatch(setLoading(false));
        return Promise.reject("InvalidOtp");
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      trackCleavertapEvent(ANALYTICS_EVENTS.OTP_Verification_Failed, {
        Phone_Number: formatPhoneNumber(phoneNumber, selectedCountryCode),
        Attempt_Number:
          incrementVerifyOtpAttempt(
            formatPhoneNumber(phoneNumber, selectedCountryCode),
          ) ?? 1,
        Failure_Reason: "incorrect_otp",
      });
      return Promise.reject("InvalidOtp");
    }
  };

export const submitRegistrationInfoAction =
  (formData: any, verifyFormData: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const contactData = {
        name: `${formData.firstName} ${formData.lastName}`,
        email: "avinash@omkarainfotech.com",
        contact: formData.phoneNumber,
        type: formData.userType,
        reference_id: "NA",
        notes: {
          random_key_1: formData.userType,
          random_key_2: formData.userType,
        },
      };
      // const paymentProfile = await CommonService.createRazorpayContact(
      //   contactData,
      // );

      const data = {
        ...formData,
        email: formData.email.toLowerCase().trim(),
        phoneNumber: `+${formData?.countryCode}${formData?.phoneNumber}`,
        ...verifyFormData,
        paymentProfile: {},
      };
      const user = await trackedAsync(()=> AuthService.handleUserRegistration(data));
      //TODO
      dispatch(setUser(user));
      localStorage.setItem(LOCALSTORAGE_KEY.USERINFO, JSON.stringify(user));
      await dispatch(
        updateLastLogin(String(user?.id), true, {
          userName: `${user?.personalInfo?.firstName ?? ""} ${user?.personalInfo?.lastName ?? ""}`,
          phoneNumber: String(user?.phoneNumber ?? ""),
          device: navigator.userAgent,
        }),
      );
      CleverTapService.onUserLogin({
        Identity: String(user?.id ?? user?.phoneNumber),
        Phone: String(user?.phoneNumber ?? ""),
        Name: `${user?.personalInfo?.firstName ?? ""} ${user?.personalInfo?.lastName ?? ""}`,
        Email: user?.personalInfo?.email || "",
        DOB: user?.personalInfo?.dateOfBirth ?? "",
        Photo: user?.personalInfo?.profilePictureUrl ?? "",
        Created_Date: getIsoTimestamp(),
        Last_Login_Date: getIsoTimestamp(),
      });
      trackCleavertapEvent(ANALYTICS_EVENTS.User_Profile_Completed, {
        User_ID: String(user?.id || user?.phoneNumber),
        Name: `${user?.personalInfo?.firstName ?? ""} ${user?.personalInfo?.lastName ?? ""}`,
        Email: user?.personalInfo?.email || "",
        Age: "",
        Gender: user?.personalInfo?.gender ? user.personalInfo.gender : "",
      });
      dispatch(setLoading(false));
      return Promise.resolve(user);
    } catch (e: any) {
      console.log("Error:", e);
      dispatch(setLoading(false));
      return Promise.reject(e);
    }
  };

export const logoutAction = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    try {
      localStorage.removeItem(LOCALSTORAGE_KEY.USERINFO);
      //clear cart as well || new user may login
      localStorage.removeItem(LOCALSTORAGE_KEY.CARTINFO);
      //clear selectedelectedAddressId as well || new user may login
      localStorage.removeItem(LOCALSTORAGE_KEY.SELECTEDADDRESSID);
      dispatch(setConfirmation(null));
      CleverTapService.logout();
      // dispatch({ type: "RESET_STORE" });
      dispatch(resetUserAction());
      dispatch(setLoading(false));
      return Promise.resolve("");
    } catch (err) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  } catch (e) {
    console.log("Error:", e);
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const getOfferData =
  (isActive = true) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const offerData: any = await CommonService.getOfferModal(isActive);

      dispatch(setOfferData(offerData.data));
      dispatch(setLoading(false));
      return Promise.resolve(offerData.data);
    } catch (error: any) {
      console.log("Error ", error);
      dispatch(setOfferData(null));
    }
  };

export const getOfferDataWeb =
  (isActive = true) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const offerData: any = await trackedAsync(()=> CommonService.getOfferModalWeb(isActive));

      dispatch(setOfferData(offerData.data));
      dispatch(setLoading(false));
      return Promise.resolve(offerData.data);
    } catch (error: any) {
      console.log("Error ", error);
      dispatch(setOfferData(null));
    }
  };
export const getActiveCountryList =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const resendResult: any = await trackedAsync(()=> CommonService.getActiveCountryList());
      dispatch(setCountryCode(resendResult?.data));
      dispatch(setLoading(false));
      return Promise.resolve(true);
    } catch (error: any) {
      console.log("Error", error);
      dispatch(setLoading(false));
      return Promise.reject(error);
    }
  };

export const searchUserByPhoneNumber =
  (countryCode: string, phoneNumber: string) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const result: any = await UserService.searchUserByPhoneNumber(
        countryCode,
        phoneNumber,
      );
      dispatch(setLoading(false));
      return Promise.resolve(result);
    } catch (error: any) {
      console.log("Error", error);
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const checkUserLoggedIn =
  (phoneNumber: any) => async (dispatch: any) => {
    try {
      dispatch(setGlobalLoader(true));
      const isUserExist =
        await trackedAsync(()=>AuthService.checkIsExistRegisterData(phoneNumber));
      if (!isUserExist) {
        dispatch(setGlobalLoader(false));
        dispatch(logoutAction());
        return Promise.resolve("");
      }
      const checkUser = await trackedAsync(()=>AuthService.handleUserLogin(phoneNumber));
      let userDetails = null;
      if (checkUser?.newUser) {
        dispatch(setLoading(false));
        userDetails = {
          newUser: checkUser.newUser,
          phoneNumber: removeCountryCode(checkUser?.phoneNumber),
        };
      } else {
        userDetails = checkUser.user;
      }
      localStorage.setItem(LOCALSTORAGE_KEY.USERINFO, JSON.stringify(userDetails));
      dispatch(setUser(userDetails));
      dispatch(setLoading(false));
      dispatch(setGlobalLoader(false));
      return Promise.resolve("");
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("InvalidOtp");
    }
  };
export const updateLastLogin =
  (userId: string, trackLoginActivity: boolean = false, meta: any = null) =>
  async (dispatch: any, getState: any) => {
    try {
      const allStates = getState();
      const ipAddress =
        allStates?.priceConversion?.priceConversionRate?.clientIp || "";
      const location = allStates?.user?.currentGPSAddress?.address || null;
      await trackedAsync(()=> AuthService.updateLastLogin(userId, trackLoginActivity, {
        ...meta,
        location: location,
        ip: ipAddress,
      }));
      return Promise.resolve("");
    } catch (error: any) {
      console.log("Error", error);
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };
